import { apiFetch, apiFetchJson } from '@wundo/client/api.ts';
import type { UnansweredConversation } from '@wundo/shared/unansweredConversations.ts';

export type { UnansweredConversation };

/**
 * Conversations whose last message is an unanswered user message — older than
 * the in-flight cutoff, inside the recency window. The backend decides both.
 */
export async function listUnansweredConversations(
  organisationId?: string,
): Promise<UnansweredConversation[]> {
  const params = new URLSearchParams({ limit: '100' });
  if (organisationId) params.set('organisation_id', organisationId);

  const { data } = await apiFetchJson<{ data: UnansweredConversation[] }>(
    `/conversations/unanswered?${params.toString()}`,
  );
  return data;
}

/** Re-dispatch processing for a stuck conversation so the user gets a reply. */
export async function retryConversation(conversationId: string): Promise<void> {
  await apiFetch(`/conversations/${conversationId}/actions/retry`, { method: 'POST' });
}
